import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import * as pas from '../../../pas';
import { useLogout } from '../../useLogout';
import { VALIDATION_TYPE } from '../constants';
import { useContinueLogin } from './useContinueLogin';
import { useValidationManager } from './useValidationManager';

export const useValidateTCVersion = (validationsRef) => {
    const logout = useLogout();
    const continueLogin = useContinueLogin();
    const closePopups = useSmartClosePopups();
    const {
        validationStart, validationDone, isValidationInProcess, areAllValidationsDone
    } = useValidationManager(VALIDATION_TYPE.ACCEPT_TERMS, validationsRef);

    const acceptTC = useCallback(({ termVersionReference, credentials, afterRegisterLogin, isAfterLoginWithCredentials }) => {
        (async () => {
            try {
                await pas.setTerms({
                    accept: true,
                    termVersionReference
                });
                validationDone();

                if (areAllValidationsDone()) {
                    await continueLogin({ credentials, afterRegisterLogin, isAfterLoginWithCredentials });
                }
            } catch {
                logout(true);
            }
        })();
    }, [continueLogin, logout, validationDone, areAllValidationsDone]);

    return useCallback((pasLoginResponse, credentials, options) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationByTCVersionData) {
            validationDone();

            return;
        }

        if (isValidationInProcess()) {
            return;
        }

        let ensureLogout = true;
        const { afterRegisterLogin, isAfterLoginWithCredentials } = options || {};
        const { tcVersionUrl, termVersionReference } = sessionValidationData.SessionValidationByTCVersionData[0] || {};

        validationStart();

        dispatcher.dispatch('app:message', {
            ID: VALIDATION_TYPE.ACCEPT_TERMS,
            data: {
                id: VALIDATION_TYPE.ACCEPT_TERMS,
                tcVersionUrl,
                onAccept: async () => {
                    await acceptTC({
                        termVersionReference,
                        credentials,
                        afterRegisterLogin,
                        isAfterLoginWithCredentials
                    });
                    ensureLogout = false;
                },
                onDecline: () => {
                    if (ensureLogout) {
                        logout(true);
                        closePopups();
                    }
                }
            }
        });
    }, [closePopups, logout, acceptTC, validationStart, validationDone, isValidationInProcess]);
};
